var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{ref:"uploader",staticClass:"uploader",attrs:{"action":'#',"http-request":_vm.onFileUpload,"headers":_vm.uploadHeaders,"before-upload":_vm.beforeUpload,"on-remove":_vm.handleRemove,"file-list":_vm.imageList,"list-type":"picture-card","multiple":true}},[_c('i',{staticClass:"el-icon-plus"})])
}
var staticRenderFns = []

export { render, staticRenderFns }